export const OutgoingCallTestIds = {
  HANGUP: 'outgoing-call.hangup-button',
};
